
const InfoTab = require('app/supplier/show/InfoTab');
const StatTab = require('app/supplier/show/StatTab');
const RestaurantTab = require('app/supplier/show/RestaurantTab');

class ShowView {
    defaultOptions() {
        return {
            'activeTab': 'info',
            'selector': '.view-supplier-show',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.onTabChange = this.onTabChange.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }


        this.initialize();
    }

    initialize() {
        var self = this;

        $('button[data-bs-toggle="tab"]',this.$container)
        .on('shown.bs.tab',this.onTabChange);

        this.loadTab(this.settings.activeTab);
    }

    onTabChange(event){

        let $shownTabBtn = $(event.target);
        let $previousShownTabBtn = $(event.relatedTarget);

        let shownTab = $shownTabBtn.data('tab');
        let previousShownTab = $previousShownTabBtn.data('tab');

        this.clearTab(previousShownTab);
        this.loadTab(shownTab);
    }

    clearTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('');
    }
    
    loadTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('')
        .append(window.App.generateLoader());

        window.setUrlParameter('tab',tab);

        switch(tab){
            case 'info':
                let infoTab = new InfoTab({
                    'supplier': this.settings.supplier,
                    '$container': $tabBody
                });
            break;
            case 'stat':
                let statTab = new StatTab({
                    'supplier': this.settings.supplier,
                    '$container': $tabBody
                });
            break;
            case 'restaurant':
                let logsTab = new RestaurantTab({
                    'supplier': this.settings.supplier,
                    '$container': $tabBody
                });

            break;
        }
    }

}

module.exports = ShowView;

